import { createAction } from '@reduxjs/toolkit';

import { TeamMemberExcelFailure } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import {
  DownloadTeamExcelRequest,
  UploadTeamExcelRequest,
  ViewTeamLeaderboardRequest,
  ViewTeamsForProgrammeRequest
} from './programme-teams.types';

export const requestViewTeamsForProgramme = createAction<SagaPayload<ViewTeamsForProgrammeRequest>['payload']>(
  'programme-teams/viewTeamsForProgramme'
);

export const requestDownloadTeamExcel = createAction<SagaPayload<DownloadTeamExcelRequest>['payload']>(
  'programme-teams/requestDownloadTeamExcel'
);

export const requestUploadTeamExcel = createAction<
  SagaPayload<UploadTeamExcelRequest, undefined, TeamMemberExcelFailure[]>['payload']
>('programme-teams/requestUploadTeamExcel');

export const requestViewTeamLeaderboard = createAction<SagaPayload<ViewTeamLeaderboardRequest>['payload']>(
  'programme-teams/requestViewTeamLeaderboard'
);
